/**
 * Split out from backoffice-auth.ts so client-bundled code (InspectorMount) can check
 * for this role without importing the admin email allowlist that file also pulls in.
 */
export const TRANSLATION_REVIEWER_ROLE = 'translation_reviewer';
